var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentSetUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Document_Set_up1_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Document_Set_up1_",
    "data-name": "Document Set up1 ",
    clipPath: "url(#clip-Document_Set_up1_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0.607 1.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(3.412 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21190",
    "data-name": "Path 21190",
    d: "M121.342-.5h5.8q-.006,1.483.013,2.966a.374.374,0,0,0,.374.374q1.483.019,2.966.013.006,4.474-.013,8.948a1.218,1.218,0,0,1-.89.9H123.25a4.4,4.4,0,0,0,1.805-3.069Q126.679,9.6,128.3,9.6q.543-.138.271-.632a.431.431,0,0,0-.271-.116q-1.625-.006-3.249-.039a5.154,5.154,0,0,0-.438-1.521q1.844.006,3.688-.013.543-.138.271-.632a.431.431,0,0,0-.271-.116L124.075,6.5a4.271,4.271,0,0,0-3.636-1.509q-.006-2.3.013-4.59A1.218,1.218,0,0,1,121.342-.5Zm1.289,4.693q2.837-.006,5.673.013.543.138.271.632a.431.431,0,0,1-.271.116q-2.837.026-5.673,0-.514-.119-.3-.606A.553.553,0,0,1,122.631,4.193Z",
    transform: "translate(-120.437 0.5)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.996,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(10.892 -0.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21191",
    "data-name": "Path 21191",
    d: "M410.5,7.5q1.191,1.172,2.372,2.36-1.186.019-2.372.013Z",
    transform: "translate(-410.5 -7.5)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.973,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0.314 5.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21192",
    "data-name": "Path 21192",
    d: "M4.213,248.146H3.388A3.509,3.509,0,0,1,1.531,242a3.548,3.548,0,0,1,3.533-.593,3.464,3.464,0,0,1,2.2,2.85,3.51,3.51,0,0,1-1.715,3.443A3.991,3.991,0,0,1,4.213,248.146Zm.722-4.539q.649-.017.425.593l-1.87,1.87a.45.45,0,0,1-.464,0,11.464,11.464,0,0,1-.89-.941q-.035-.65.58-.426l.516.516a.032.032,0,0,0,.052,0Q4.094,244.39,4.935,243.607Z",
    transform: "translate(-0.314 -241.175)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.987,
    style: {
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSetUp);
export default __webpack_public_path__ + "static/media/DocumentSetUp.e4425301773199dc07ea63332c2db5f9.svg";
export { ForwardRef as ReactComponent };